import { BaseModel } from '../base.model';
import {required} from '../json-map.util';

class SolutionRequest {}

namespace SolutionRequest {


  export class Create extends BaseModel {

    @required()
    title: string = undefined;

    @required()
    correctAnswer: string = undefined;
    @required()
    wrongAnswers: string = undefined;
    @required()
    problemId: number = undefined;
  }

  export class Update extends BaseModel {

    title: string = undefined;
    correctAnswer: string = undefined;
    wrongAnswers: string = undefined;

  }


}

export { SolutionRequest };

